import { render, staticRenderFns } from "./IcoSkillsDomainLeadership.vue?vue&type=template&id=0af6a106"
import script from "./IcoSkillsDomainLeadership.vue?vue&type=script&lang=js"
export * from "./IcoSkillsDomainLeadership.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports